import * as Constants from '../constants'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from "./ContatoPage.module.css";
import { faBedPulse, faCircleInfo, faPaperPlane, faShare } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import Captcha from '../components/widget/Captcha';
import Swal from 'sweetalert2';

function ContatoPage() {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [f, setF] = useState("");
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [messageSent, setMessageSent] = useState(false);

  const messageDialog = (message, type = 'warning') => {
    Swal.fire({
      title: type === 'warning' ? 'Atenção!' : 'Falha!',
      text: message,
      icon: type,
      confirmButtonText: 'FECHAR',
      // Customização direta das cores dos botões:
      // confirmButtonColor: '#00ff08', // Verde
      // cancelButtonColor: '#d33',     // Vermelho        
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        if (confirmButton) {
          // Aplicação dos estilos diretamente no botão de confirmação
          Object.assign(confirmButton.style, {
            padding: '10px 40px',
            fontSize: '18px',
            fontWeight: '600',
            backgroundColor: '#00FF08',
            border: '0',
            borderRadius: '30px',
            cursor: 'pointer',
            transition: '.2s',
            color: '#000'
          });
        }
      }
    });
  }

  const disableCodeInput = (disabled) => {
    const codeInput = document.getElementById('code');
    if (codeInput) {
      codeInput.disabled = disabled;
    }
  }

  const handleClick = async (event) => {
    event.preventDefault();
    Swal.fire({
      title: "Enviando mensagem!",
      text: "Aguarde...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      backdrop: true
    });

    const form = event.currentTarget.closest('form');
    const nome = form.nome.value.trim();
    const email = form.email.value.trim();
    const telefone = form.telefone.value.trim();
    const mensagem = form.mensagem.value.trim();
    const f = form.f.value.trim();
    const code = form.code.value.trim();
    // const codeInput = document.getElementById('code');

    disableCodeInput(true)

    // Validação em JavaScript
    if (!nome) {
      messageDialog('Por favor, informe o seu nome.');
      form.nome.focus();
      disableCodeInput(false);
      return;
    }

    if (!email) {
      messageDialog('Por favor, preencha o e-mail.');
      form.email.focus();
      disableCodeInput(false);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      messageDialog('Por favor, informe um e-mail válido.');
      form.email.focus();
      disableCodeInput(false);
      return;
    }

    if (!mensagem) {
      messageDialog('Por favor, digite a sua mensagem.');
      form.mensagem.focus();
      disableCodeInput(false);
      return;
    }

    if (!code) {
      messageDialog('Por favor, digite o código.');
      form.code.focus();
      disableCodeInput(false);

      return;
    }

    const dados = {
      nome,
      email,
      telefone: telefone || null,
      mensagem,
      f,
      code
    };

    // if (codeInput) {
    //   codeInput.disabled = true;
    // }

    setIsLoading(true);

    // Usando await apenas para iniciar o fetch de forma limpa
    await fetch(Constants.CONTACT, {
      method: 'POST',
      headers: {
        // REMOVIDO: 'Content-Type': 'application/json'
        'Accept': '*/*'
      },
      // O navegador define o Content-Type correto para formulários automaticamente aqui
      body: new URLSearchParams(dados),
    })
      .then(async response => {
        // Executado se a requisição for bem-sucedida

        // PROTEÇÃO ANTI-QUEBRA: Verifica se a resposta é realmente um JSON válido antes de ler
        const contentType = response.headers.get("content-type");
        let responseJson = {};

        if (contentType && contentType.includes("application/json")) {
          responseJson = await response.json();
        } else {
          // Se o PHP retornar HTML devido ao Erro 409, pegamos como texto para não quebrar a aplicação
          const textoErro = await response.text();
          throw new Error(`Servidor não retornou JSON. Resposta: ${textoErro.substring(0, 100)}...`);
        }

        if (!response.ok) {
          throw new Error(
            responseJson.message || `Erro HTTP ${response.status}`
          );
        }

        return responseJson;
      })
      .then(responseJson => {
        // Executado após a conversão para JSON ser concluída
        if (responseJson.sucesso) {
          // console.log('Mensagem enviada:', responseJson.message);
          Swal.close();

          messageDialog('Mensagem enviada com sucesso.', 'success');
          setNome("");
          setEmail("");
          setTelefone("");
          setMensagem("");
          setCode("");
          setIsLoading(false);
          setMessageSent(true);
          disableCodeInput(true);
        } else {
          messageDialog('Não foi possível enviar mensagem.', 'error');
          setIsLoading(false);
          setMessageSent(false);
          disableCodeInput(false);
        }
      })
      .catch(error => {
        // Executado se ocorrer qualquer erro no fluxo anterior
        if (error.name === 'AbortError') {
          return;
        }

        console.error(
          'Erro na requisição:',
          error.message || error
        );
      })
      .finally(() => {
        // Executado SEMPRE no final, independentemente de ter dado certo ou errado
        var delayInMilliseconds = 3000;
        setTimeout(function () {
          //your code to be executed after 1 second
        }, delayInMilliseconds);
        // window.location.reload();
      });
  };

  return (
    <main>
      <section id="contato" className={classes.formulario}>
        <div className="interface">
          <h2 className="titulo">FALE<span> CONOSCO.</span></h2>

          {(!messageSent) &&
            <form>
              <input
                type="text"
                name="nome"
                id="nome"
                value={nome}
                placeholder="* Seu nome"
                onChange={(e) => setNome(e.target.value)}
                disabled={isLoading}
              />
              <input
                type="email"
                name="email"
                id="email"
                value={email}
                placeholder="* Seu e-mail"
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
              />
              <input
                type="text"
                name="telefone"
                id="telefone"
                value={telefone}
                placeholder="Seu celular"
                onChange={(e) => setTelefone(e.target.value.replace(/\D/g, "").slice(0, 13))}
                disabled={isLoading}
                maxLength={13}
              />
              <textarea
                name="mensagem"
                id="mensagem"
                value={mensagem}
                placeholder="* Sua mensagem"
                onChange={(e) => setMensagem(e.target.value)}
                disabled={isLoading}
              ></textarea>

              <Captcha
                url={"https://terradata.com.br/lib/captcha"}
              />

              <div className={classes.btnEnviar}>
                <div className={`btnContato ${classes.btnContato}`}>
                  <button type="button" onClick={handleClick} disabled={isLoading}>
                    <FontAwesomeIcon icon={faShare} />&nbsp;&nbsp;ENVIAR
                  </button>
                </div>
              </div>
            </form>
          }

          {messageSent &&
            <div className='col-md-12 text-center pt-3'><br /><br /><br /><br />
              <h5 className='text-light'>Mensagem enviada com sucesso!</h5>
              <br /><br />
            </div>
          }

        </div>
      </section>
      <br />
    </main >
  );
}

export default ContatoPage;